import * as React from "react";
const SvgChevronDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white", fillOpacity: 0.01, style: {
  mixBlendMode: "multiply"
} }), /* @__PURE__ */ React.createElement("path", { d: "M8 10.9969L3 5.99687L3.7 5.29688L8 9.59688L12.3 5.29688L13 5.99687L8 10.9969Z", fill: "#161616" }));
export default SvgChevronDown;
